exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#point .modal-body.question-multiple,#point .modal-body.question-single{padding:0}#point .table{margin-bottom:0}#point .table tr:first-child td{border-top:0}#point .form-check-label-text{padding-left:1px}#point .answer-validity{white-space:nowrap;vertical-align:middle}#point .file-input{width:.1px;height:.1px;opacity:0;overflow:hidden;position:absolute;z-index:-1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-ea1593f4!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/point.vue
// module id = 353
// module chunks = 0